import { storage } from '../lib/storage';
import { LOG_DEBUG_NAMESPACE, FEATURE_FLAGS } from './constants';

/**
 * Check if flag to expose loggs is enabled/setted in
 * localStorage to show logs
 *
 * @param  {string}  namespace Product namespace identifier
 * @return {boolean}
 */
function isDebuggerEnable(namespace: string): boolean {
  const namespacesWithDebugEnabled = storage.local.get<string>(LOG_DEBUG_NAMESPACE);
  const namespaces = namespacesWithDebugEnabled ? namespacesWithDebugEnabled.split(',').map((flag) => flag.trim()) : [];
  return namespaces.includes(namespace.trim());
}

/**
 * Check if namespace is suffix by group to grouping
 * logs for namespace
 *
 * @param  {string}  namespace Product namespace identifier
 * @return {boolean}
 */
function isDebuggerGrouped(namespace: string): boolean {
  const namespacesWithDebugEnabled = storage.local.get<string>(LOG_DEBUG_NAMESPACE);
  const namespaces = namespacesWithDebugEnabled ? namespacesWithDebugEnabled.split(',').map((flag) => flag.trim()) : [];
  return namespaces
    .filter((key: string) => key.trim().startsWith(namespace))
    .some((key: string) => key.trim().endsWith('GROUP'));
}

/**
 * Check if flag is present in localStorage on the scope key.
 * It can have multiple flags separated by comma.
 *
 * @param {string} flag Feature flag name
 * @param {string} scope Localstorage key, by default: b2x.feature-flags
 * @return {boolean}
 */
function isFeatureFlagEnabled(flag: string, scope: string = FEATURE_FLAGS): boolean {
  const featureFlagsAvailable = storage.local.get<string>(scope);
  const flags = featureFlagsAvailable ? featureFlagsAvailable.split(',').map((flag) => flag.trim()) : [];
  return flags.includes(flag.trim());
}

export { isDebuggerEnable, isDebuggerGrouped, isFeatureFlagEnabled };
